import { useQuery } from '@tanstack/react-query';

import fetchAuditTrail from '@data/auditTrail/fetchAuditTrail';

const getAuditTrail = ({ queries }) => {
    return useQuery({
        queryKey: ['audit-trail', queries],
        queryFn: () => fetchAuditTrail({ queries }),
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
    });
};

export default getAuditTrail;
